// AuthHeader.tsx - Google Modern auth header component
// Genesis v3.0 standard: Micro-module under 100 lines

import type { LucideIcon } from 'lucide-react';
import React from 'react';

interface AuthHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  error?: string | null;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ icon: Icon, title, subtitle, error }) => {
  return (
    <>
      <div className="w-12 h-12 bg-[var(--color-primary-base)] rounded-xl flex items-center justify-center text-[var(--color-content-inverse)] mb-8 shadow-sm">
        <Icon size={24} />
      </div>

      <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-[var(--color-content-primary)] mb-2">{title}</h1>
      <p className="text-[var(--color-content-secondary)] mb-8 font-medium">{subtitle}</p>

      {error && (
        <div className="mb-6 p-4 bg-[var(--color-danger-subtle)] border border-[var(--color-danger-base)]/20 rounded-xl">
          <p className="text-[var(--color-danger-base)] text-sm font-medium">{error}</p>
        </div>
      )}
    </>
  );
};

export default AuthHeader;

